/*******************************************************************************
 * Copyright (c) 2025 Passport Fintech Inc. All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 ******************************************************************************/

import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {ModuleWithProviders, NgModule, inject} from '@angular/core';
import {AuthInterceptor} from '@common-core/interceptors/auth/auth.interceptor';

/**
 * This module is used to initialize all the DI tokens needed for the HttpInterceptor specific for PaaS
 * Those include:
 * - Setting the HTTP_INTERCEPTORS to include the AuthInterceptor
 * - Setting the HTTP_INTERCEPTORS to include the ClientCredentialsInterceptor
 */
@NgModule({})
export class PaasInterceptorsModule {
  constructor() {
    const parentModule = inject(PaasInterceptorsModule, {optional: true, skipSelf: true});

    if (parentModule) {
      throw new Error(
        'PaasInterceptorsModule is already loaded. Import it in the AppModule only'
      );
    }
  }

  static forRoot(): ModuleWithProviders<PaasInterceptorsModule> {
    return {
      ngModule: PaasInterceptorsModule,
      providers: [
        {
          provide: HTTP_INTERCEPTORS,
          useClass: AuthInterceptor,
          multi: true,
        },
      ],
    };
  }
}
